import SparePartsFinderIndexTableRow from '../SparePartsFinderIndexTableRow';
import store from '@lib/store/SparePartsFinderTextSearchBasketStore';
import SparePartsFinderAddToBasket from '../SparePartsFinderAddToBasket';

export default class SparePartsFinderTextSearchIndexTableRow extends SparePartsFinderIndexTableRow {

    renderDescriptionContainer() {
        return (
            <div className="text-search-index-table-row">
                {this.renderDescription()}
                {this.renderBlocks()}
            </div>
        )
    }

    renderBlocks() {
        return (
            <span className="blocks">
                {this.props.row.blocks.map(x => (
                    <span className="block">{x}</span>
                ))}
            </span>
        )
    }

    renderActions() {
        return (
            <SparePartsFinderAddToBasket
                isInBasket={store.isInBasket(this.props.productSerialNumber, this.props.row.id)}
                onAddToBasketClick={this.addToBasket}
            />
        )
    }
}